export const AddressLinkStyles = {
  icon: (cssLogoClasses: string | undefined) => cssLogoClasses ?? 'mr-4 w-4.5',
  link: (className: string = '') => `${className} flex items-center `,
}
